import React, { Component } from "react";
import "./facturacion.css";
import Navbar from "../../componentes/navbar/navbar";
import SpinnerModal from "../../componentes/spiner/SpinnerModal";
import { toast } from "react-toastify";
import { DatePicker } from "react-rainbow-components";
import { FaSyncAlt } from "react-icons/fa";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { BsFiletypeXml } from "react-icons/bs";
import { cancelarFacturaPublica, descargarFacturaxml, getDetallesFacturaPublica, getFacturacion, getFacturacionDetalles, getFacturaPublica, getListSat, guardarFacturaPublica, guardarNotaCredito, guardarNotaCreditoGeneral, } from "../../service/api";
import GenerarFacturaModal from "../../componentes/modal/facturacion/GenerarFacturaModal";
import FacturaPublicaDetalleModal from "../../componentes/modal/facturacion/FacturaPublicaDetalleModal";
import VerDetallesFacModal from "../../componentes/modal/facturacion/VerDetallesFacModal";

export default class FacturacionPage extends Component {
    state = {
        loading: false,
        fecha: localStorage.getItem("facturacion_fecha") || this.toISODate(new Date()),
        facturas: [],
        sortKey: "idfactura",
        sortDir: "desc",
        selectedRowId: null,
        q: "",
        catalogos: null,
        catalogLoading: false,

        showDetalle: false,
        detalleLoading: false,
        facturaSel: null,
        datapadre: null,

        showGenerar: false,
        generarLoading: false,
        facturaPublicaData: [],
        motivo_cancelacion: [],


        showFacturaPublicaDetalle: false,
        facturaPublicaDetalleLoading: false,
        facturaPublicaDetalleData: null,

        // NUEVO MODAL VER
        showVerDetallesFac: false,
        verDetallesFacLoading: false,
        verDetallesFacData: null,
    };

    async componentDidMount() {
        const datos = localStorage.getItem("datosm");
        if (!datos || datos === "") {
            window.location.href = "/";
            return;
        }

        this.setState({ loading: true });

        await this.loadCatalogos();
        await this.fetchFacturacion(this.state.fecha);
    }

    // ===== Helpers =====
    toISODate(dateObj) {
        const y = dateObj.getFullYear();
        const m = String(dateObj.getMonth() + 1).padStart(2, "0");
        const d = String(dateObj.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    }

    parseISOToDate = (iso) => {
        if (!iso) return new Date();
        const [y, m, d] = String(iso).split("-").map(Number);
        return new Date(y, (m || 1) - 1, d || 1);
    };

    money = (n) => {
        const val = Number(n || 0);
        return val.toLocaleString("es-MX", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    normalizeText = (v) =>
        String(v ?? "")
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");

    compareValues = (a, b) => {
        if (a == null) a = "";
        if (b == null) b = "";

        const na = Number(a);
        const nb = Number(b);

        const bothNumeric =
            !Number.isNaN(na) &&
            !Number.isNaN(nb) &&
            String(a).trim() !== "" &&
            String(b).trim() !== "";

        if (bothNumeric) return na - nb;

        return String(a).localeCompare(String(b), "es", {
            numeric: true,
            sensitivity: "base",
        });
    };

    // ===== API =====
    fetchFacturacion = async (fechaISO) => {
        this.setState({ loading: true });

        try {
            const resp = await getFacturacion({ fecha: fechaISO });

            if (resp?.code === 0) {
                const raw = resp?.data || [];
                const arr = Array.isArray(raw) ? raw : raw?.data || [];
                this.setState({
                    facturas: arr,
                    loading: false,
                    selectedRowId: null,
                });
                return;
            }

            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            this.setState({ loading: false });
            toast.info(resp?.message || "No se pudo cargar facturación.");
        } catch (e) {
            this.setState({ facturas: [], loading: false });
            toast.info("Error al cargar facturación.");
        }
    };

    refreshFacturacion = async () => {
        try {
            this.setState({ loading: true });
            await this.fetchFacturacion(this.state.fecha);
        } catch (e) { }
    };

    // ===== UI handlers =====
    onChangeFecha = (dateObj) => {
        if (!dateObj) return;
        const fechaISO = this.toISODate(dateObj);
        localStorage.setItem("facturacion_fecha", fechaISO);
        this.setState({ fecha: fechaISO }, () => this.fetchFacturacion(fechaISO));
    };

    setHoy = () => {
        const hoyISO = this.toISODate(new Date());
        localStorage.setItem("facturacion_fecha", hoyISO);
        this.setState({ fecha: hoyISO }, () => this.fetchFacturacion(hoyISO));
    };

    onSelectRow = (rowId) => {
        this.setState((prev) => ({
            selectedRowId: prev.selectedRowId === rowId ? null : rowId,
        }));
    };

    // ===== Sorting =====
    getSortValue = (f, key) => {
        switch (key) {
            case "idticket":
                return f.idticket;
            case "idfactura":
                return f.idfactura;
            case "tipo_factura":
                return f.tipo_factura;
            case "folio":
                return f.folio;
            case "nombre":
                return f.nombre;
            case "rfc":
                return f.rfc;
            case "cantidad":
                return f.cantidad;
            case "moneda":
                return f.moneda;
            case "afiliacion":
                return f.afiliacion;
            case "banco":
                return f.banco;
            case "hora":
                const h = String(f.hora || "00:00:00").split(":").map(Number);
                return (h[0] * 3600) + (h[1] * 60) + h[2];
            case "estatus":
                return f.estatus;
            default:
                return "";
        }
    };

    onSort = (key) => {
        this.setState((prev) => {
            const same = prev.sortKey === key;
            const nextDir = same && prev.sortDir === "asc" ? "desc" : "asc";
            return { sortKey: key, sortDir: nextDir };
        });
    };

    getSortedItems = () => {
        const { facturas, sortKey, sortDir } = this.state;

        return [...(facturas || [])].sort((fa, fb) => {
            const a = this.getSortValue(fa, sortKey);
            const b = this.getSortValue(fb, sortKey);
            const cmp = this.compareValues(a, b);
            return sortDir === "asc" ? cmp : -cmp;
        });
    };

    loadCatalogos = async () => {
        try {
            this.setState({ catalogLoading: true });

            const resp = await getListSat();

            if (resp?.code !== 0) {
                this.setState({ catalogLoading: false });
                toast.info(resp?.message || "No fue posible cargar catálogos SAT.");
                return;
            }

            this.setState({
                catalogos: resp?.data || {
                    forma_pago: [],
                    metodo_pago: [],
                    regimen_fiscal: [],
                    uso_cfdi: [],
                    tipo_comprobante: [],
                    meses: [],
                    periodicidades: [],
                    motivo_cancelacion: [],
                    tipo_relacion: [],
                },
                catalogLoading: false,
            });
        } catch (e) {
            this.setState({ catalogLoading: false });
            toast.info("Error al cargar catálogos SAT.");
        }
    };

    getFilteredItems = (items) => {
        const q = this.normalizeText(this.state.q).trim();
        if (!q) return items;

        return (items || []).filter((f) => {
            const hay = [
                f?.idticket,
                f?.idfactura,
                f?.tipo_factura,
                f?.folio,
                f?.nombre,
                f?.rfc,
                f?.cantidad,
                f?.moneda,
                f?.afiliacion,
                f?.banco,
                f?.hora,
                f?.estatus,
            ]
                .map(this.normalizeText)
                .join(" ");

            return hay.includes(q);
        });
    };

    // ===== Estatus =====
    getEstatusClass = (estatus) => {
        const t = String(estatus || "").toLowerCase();

        if (t.includes("facturado") || t.includes("vigente")) return "green";
        if (t.includes("cancelado")) return "warn";
        if (t.includes("pendiente")) return "blue";

        return "none";
    };

    // ===== Descargas =====
    downloadBase64File = (base64Data, fileName, mimeType) => {
        try {
            const cleanBase64 = String(base64Data || "").replace(/^data:.*;base64,/, "");
            const byteChars = atob(cleanBase64);
            const byteNumbers = new Array(byteChars.length);

            for (let i = 0; i < byteChars.length; i++) {
                byteNumbers[i] = byteChars.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: mimeType });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);
        } catch (e) {
            toast.info("No se pudo descargar el archivo.");
        }
    };

    onDescargarXml = async (f, e) => {
        e.stopPropagation();

        try {
            const folio = f?.folio || f?.uuid || f?.idticket;
            if (!folio) {
                toast.info("No se encontró el folio para descargar XML.");
                return;
            }

            const resp = await descargarFacturaxml(folio);

            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            if (resp?.code !== 0) {
                toast.info(resp?.message || "No se pudo descargar el XML.");
                return;
            }

            const file64 = resp?.data?.file || resp?.file || resp?.data;
            if (!file64) {
                toast.info("No se recibió el XML para descargar.");
                return;
            }

            this.downloadBase64File(
                file64,
                `factura_${folio}.xml`,
                "application/xml"
            );
        } catch (err) {
            toast.info("Error al descargar XML.");
        }
    };

    onDescargarPdf = async (f, e) => {
        e.stopPropagation();

        try {
            const folio = f?.folio || f?.uuid || f?.idticket;
            if (!folio) {
                toast.info("No se encontró el folio para descargar PDF.");
                return;
            }

            const resp = {}; // await descargarFacturapdf(folio);

            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            if (resp?.code !== 0) {
                toast.info(resp?.message || "No se pudo descargar el PDF.");
                return;
            }

            const file64 = resp?.data?.file || resp?.file || resp?.data;
            if (!file64) {
                toast.info("No se recibió el PDF para descargar.");
                return;
            }

            this.downloadBase64File(
                file64,
                `factura_${folio}.pdf`,
                "application/pdf"
            );
        } catch (err) {
            toast.info("Error al descargar PDF.");
        }
    };

    // ===== Modal Generar =====
    refreshFacturaPublicaByFecha = async (fechaISO) => {
        try {
            this.setState({
                generarLoading: true,
                facturaPublicaData: [],
            });

            const resp = await getFacturaPublica({ fecha: fechaISO });

            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            if (resp?.code === 0) {
                const arr = Array.isArray(resp?.data) ? resp.data : [];

                this.setState({
                    facturaPublicaData: arr,
                    generarLoading: false,
                });

                if (arr.length === 0) {
                    toast.info("No hay pendientes de facturación para la fecha seleccionada.");
                }

                return;
            }

            this.setState({
                facturaPublicaData: [],
                generarLoading: false,
            });

            toast.info(resp?.message || "No se pudo consultar la fecha seleccionada.");
        } catch (e) {
            this.setState({
                facturaPublicaData: [],
                generarLoading: false,
            });

            toast.info("Error al consultar factura pública.");
        }
    };

    openGenerar = async () => {
        try {
            this.setState({ loading: true });

            const resp = await getFacturaPublica({ fecha: this.state.fecha });

            if (resp?.code === 0) {
                this.setState({
                    showGenerar: true,
                    facturaPublicaData: resp?.data || [],
                    loading: false,
                });
            } else {
                this.setState({
                    loading: false,
                    showGenerar: false,
                    facturaPublicaData: [],
                });
                toast.info(resp?.message || "Seleccione otra fecha para generar factura.");
                return;
            }
        } catch (e) {
            this.setState({
                loading: false,
                showGenerar: false,
                facturaPublicaData: [],
            });
            toast.info("Error al consultar factura pública.");
        }
    };

    onSaveFActura = async (payload) => {
        const afiliacion = String(payload?.afiliacion || "").trim();

        if (!afiliacion) {
            toast.info("No se encontró la afiliación para actualizar.");
            return;
        }

        try {
            this.setState({ facturaPublicaDetalleLoading: true });

            const resp = await guardarFacturaPublica(payload);

            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            if (resp?.code === 0) {
                toast.success(resp?.message || "Factura pública actualizada correctamente.");

                this.setState({
                    showFacturaPublicaDetalle: false,
                    showGenerar: false,
                    facturaPublicaDetalleData: null,
                    facturaPublicaData: [],
                    facturaSel: null,
                });
            } else {
                toast.info(resp?.message || "No fue posible guardar la factura pública.");
                this.setState({
                    showFacturaPublicaDetalle: false,
                    showGenerar: false,
                    facturaPublicaDetalleData: null,
                    facturaPublicaData: [],
                    facturaSel: null,
                });
            }
        } catch (e) {
            toast.info("No fue posible guardar la factura pública.");
        } finally {
            await this.fetchFacturacion(this.state.fecha);
        }
    };

    openFacturaPublicaDetalle = async (row, esfecha) => {
        console.log("aaaaa", esfecha);
        console.log("-- Row seleccionada para detalle:", row);
        const afiliacion = row?.afiliacion || "";

        await this.refreshFacturaPublicaDetalle(afiliacion, esfecha);


    };

    closeFacturaPublicaDetalle = () => {
        if (this.state.facturaPublicaDetalleLoading) return;

        this.setState({
            showFacturaPublicaDetalle: false,
            facturaPublicaDetalleData: null,
        });
    };

    closeGenerar = () => {
        if (this.state.generarLoading) return;

        this.setState(
            {
                showGenerar: false,
                facturaPublicaData: [],
                facturaSel: null,
            },
            () => this.fetchFacturacion(this.state.fecha)
        );
    };

    refreshFacturaPublicaDetalle = async (afiliacion, fechag) => {
        try {
            this.setState({ facturaPublicaDetalleLoading: true });

            const json = {
                fecha: fechag,
                afiliacion: afiliacion || "",
            };

            const resp = await getDetallesFacturaPublica(json);

            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            if (resp?.code === 0) {
                this.setState({
                    showFacturaPublicaDetalle: true,
                    facturaPublicaDetalleLoading: false,
                    facturaPublicaDetalleData: resp?.data || null,
                });
                return;
            }

            this.setState({
                facturaPublicaDetalleLoading: false,
            });

            toast.info(resp?.message || "No fue posible actualizar el detalle.");
        } catch (e) {
            this.setState({
                facturaPublicaDetalleLoading: false,
            });

            toast.info("No fue posible actualizar el detalle.");
        }
    };

    // ===== NUEVO MODAL VER DETALLE FACTURA =====
    // ===== NUEVO MODAL VER DETALLE FACTURA =====
    openDetalle = async (f, e) => {
        e.stopPropagation();

        const idfactura = Number(f?.idfactura || 0);

        if (!idfactura) {
            toast.info("No se encontró el idfactura.");
            return;
        }



        try {
            this.setState({
                verDetallesFacLoading: true,

                verDetallesFacData: null,
            });

            const resp = await getFacturacionDetalles(idfactura);

            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            if (resp?.code !== 0) {
                this.setState({
                    verDetallesFacLoading: false,
                    showVerDetallesFac: false,
                    verDetallesFacData: null,
                });
                toast.info(resp?.message || "No fue posible obtener el detalle de la factura.");
                return;
            }

            this.setState({
                verDetallesFacLoading: false,
                showVerDetallesFac: true,
                verDetallesFacData: resp?.data || null,
                datapadre: f,
            });
        } catch (error) {
            this.setState({
                verDetallesFacLoading: false,
                showVerDetallesFac: false,
                verDetallesFacData: null,
            });
            toast.info("No fue posible obtener el detalle de la factura.");
        }
    };

    closeVerDetallesFac = () => {
        if (this.state.verDetallesFacLoading) return;

        this.setState({
            showVerDetallesFac: false,
            verDetallesFacLoading: false,
            verDetallesFacData: null,
        });
    };

    onCancelarFacturaFromVer = async (payload) => {
        try {
            this.setState({ verDetallesFacLoading: true });

            const resp = await cancelarFacturaPublica(payload);

            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            if (resp?.code !== 0) {
                this.setState({ verDetallesFacLoading: false });
                toast.info(resp?.message || "No fue posible cancelar la factura.");
                return;
            }

            toast.success("Factura cancelada correctamente.");

            this.setState({
                showVerDetallesFac: false,
                verDetallesFacLoading: false,
                verDetallesFacData: null,
                datapadre: null,
            });

            await this.fetchFacturacion(this.state.fecha);
        } catch (e) {
            this.setState({ verDetallesFacLoading: false });
            toast.info("No fue posible cancelar la factura.");
        }
    };

    ////
    guardarNotaCreditoGeneralFromVer = async (json) => {
        try {
            this.setState({ verDetallesFacLoading: true });

            const resp = await guardarNotaCreditoGeneral(json);

            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            if (resp?.code !== 0) {
                this.setState({ verDetallesFacLoading: false });
                toast.info(resp?.message || "No se pudo guardar la nota de crédito general.");
                return;
            }

            toast.success(resp?.message || "Nota de crédito general guardada.");

            const idfactura = Number(this.state?.datapadre?.idfactura || 0);

            if (idfactura > 0) {
                const detalleResp = await getFacturacionDetalles(idfactura);

                if (detalleResp?.code === 0) {
                    this.setState({
                        verDetallesFacData: detalleResp?.data || null,
                        verDetallesFacLoading: false,
                    });

                    await this.fetchFacturacion(this.state.fecha);
                    return;
                }
            }

            this.setState({ verDetallesFacLoading: false });
            await this.fetchFacturacion(this.state.fecha);
        } catch (e) {
            this.setState({ verDetallesFacLoading: false });
            toast.info("No se pudo guardar la nota de crédito general.");
        }
    };
    /////

    onNotaCreditoFromVer = async (payload) => {
        try {
            this.setState({ verDetallesFacLoading: true });

            const resp = await guardarNotaCredito(payload);

            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            if (resp?.code !== 0) {
                this.setState({ verDetallesFacLoading: false });
                toast.info(resp?.message || "No fue posible agregar la nota de crédito.");
                return;
            }

            toast.success("Nota de credito agregada exitosamente");

            const idfactura = Number(this.state?.datapadre?.idfactura || 0);

            if (idfactura > 0) {
                const detalleResp = await getFacturacionDetalles(idfactura);

                if (detalleResp?.code === 0) {
                    this.setState({
                        verDetallesFacData: detalleResp?.data || null,
                        verDetallesFacLoading: false,
                    });
                    await this.fetchFacturacion(this.state.fecha);
                    return;
                }
            }

            this.setState({ verDetallesFacLoading: false });
            await this.fetchFacturacion(this.state.fecha);
        } catch (e) {
            this.setState({ verDetallesFacLoading: false });
            toast.info("No fue posible agregar la nota de crédito.");
        }
    };

    renderFacturaIcons = (f) => {
        const foliog = String(f?.folio || "").toLowerCase();
        const enabled = foliog == null ? false : true;

        return (
            <div className="fa-files" onClick={(e) => e.stopPropagation()}>
                <button
                    type="button"
                    className={`fa-fileBtn ${enabled ? "is-enabled" : "is-disabled"}`}
                    onClick={(e) => enabled && this.onDescargarXml(f, e)}
                    title={enabled ? "Descargar XML" : "XML no disponible"}
                    disabled={!enabled}
                >
                    <BsFiletypeXml />
                </button>

                <button
                    type="button"
                    className={`fa-fileBtn ${enabled ? "is-enabled" : "is-disabled"}`}
                    onClick={(e) => enabled && this.onDescargarPdf(f, e)}
                    title={enabled ? "Descargar PDF" : "PDF no disponible"}
                    disabled={!enabled}
                >
                    <MdOutlinePictureAsPdf />
                </button>
            </div>
        );
    };

    render() {
        const { loading, fecha, selectedRowId } = this.state;
        const sorted = this.getSortedItems();
        const items = this.getFilteredItems(sorted);

        return (
            <div className="v-page">
                <Navbar />

                {loading ? <SpinnerModal tipo="full" show={loading} /> : null}

                <FacturaPublicaDetalleModal
                    show={this.state.showFacturaPublicaDetalle}
                    loading={this.state.facturaPublicaDetalleLoading}
                    data={this.state.facturaPublicaDetalleData}
                    catalogos={this.state.catalogos}
                    onClose={this.closeFacturaPublicaDetalle}
                    onSave={this.onSaveFActura}
                />

                <VerDetallesFacModal
                    show={this.state.showVerDetallesFac}
                    loading={this.state.verDetallesFacLoading}
                    datapadre={this.state.datapadre}
                    catalogos={this.state.catalogos}
                    data={this.state.verDetallesFacData}
                    onClose={this.closeVerDetallesFac}
                    onCancelarFactura={this.onCancelarFacturaFromVer}
                    onNotaCredito={this.onNotaCreditoFromVer}
                    onNotaCreditoGeneral={this.guardarNotaCreditoGeneralFromVer}
                />

                <GenerarFacturaModal
                    show={this.state.showGenerar}
                    data={this.state.facturaPublicaData}

                    fecha={this.state.fecha}
                    loading={this.state.generarLoading}
                    onClose={this.closeGenerar}
                    onFacturar={this.openFacturaPublicaDetalle}
                />

                <div className="so-shell">
                    <div className="v-top">
                        <h1 className="v-title">Facturación</h1>

                        <div className="v-actions">
                            <div className="so-search">
                                <span className="so-ico" aria-hidden="true">🔎</span>
                                <input
                                    type="text"
                                    value={this.state.q}
                                    onChange={(e) =>
                                        this.setState({ q: e.target.value, selectedRowId: null })
                                    }
                                    placeholder="Buscar ticket, UUID, receptor, RFC..."
                                    disabled={loading}
                                />
                                {String(this.state.q || "").length > 0 && (
                                    <button
                                        type="button"
                                        className="so-clear"
                                        onClick={() => this.setState({ q: "", selectedRowId: null })}
                                        disabled={loading}
                                        aria-label="Limpiar búsqueda"
                                        title="Limpiar"
                                    >
                                        ✕
                                    </button>
                                )}
                            </div>

                            <div className="v-date">
                                <button
                                    type="button"
                                    className="v-btnHoy"
                                    onClick={this.setHoy}
                                    disabled={loading}
                                    title="Fecha actual"
                                >
                                    Hoy
                                </button>

                                <DatePicker
                                    id="facturacion-date"
                                    value={this.parseISOToDate(fecha)}
                                    onChange={this.onChangeFecha}
                                    formatStyle="large"
                                    placeholder="Selecciona fecha"
                                />

                                <button
                                    type="button"
                                    className="v-btnRefresh"
                                    onClick={this.refreshFacturacion}
                                    disabled={loading}
                                    title="Refrescar"
                                >
                                    <FaSyncAlt />
                                </button>
                            </div>

                            <button
                                className="v-btn"
                                onClick={this.openGenerar}
                            >
                                GENERAR FACTURA
                            </button>
                        </div>
                    </div>

                    <div className="vard">
                        <div className="v-card">
                            <div className="v-tableWrap">
                                <table className="v-table v-table--fact">
                                    <thead>
                                        <tr>
                                            <th className="v-thSort" onClick={() => this.onSort("idticket")}>Ticket</th>
                                            <th className="v-thSort" onClick={() => this.onSort("tipo_factura")}>Tipo</th>
                                            <th className="v-thSort" onClick={() => this.onSort("folio")}>UUID</th>
                                            <th className="v-thSort" onClick={() => this.onSort("nombre")}>Receptor</th>
                                            <th className="v-thSort" onClick={() => this.onSort("rfc")}>RFC</th>
                                            <th className="v-thSort v-num" onClick={() => this.onSort("cantidad")}>Cantidad</th>
                                            <th className="v-thSort" onClick={() => this.onSort("moneda")}>Moneda</th>
                                            <th className="v-thSort" onClick={() => this.onSort("afiliacion")}>Afiliación</th>
                                            <th className="v-thSort" onClick={() => this.onSort("banco")}>Banco</th>
                                            <th className="v-thSort" onClick={() => this.onSort("hora")}>Hora</th>
                                            <th className="v-thSort" onClick={() => this.onSort("estatus")}>Estatus</th>
                                            <th>Factura</th>
                                            <th>Detalles</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {items.length === 0 ? (
                                            <tr>
                                                <td colSpan="13" className="v-empty">
                                                    {this.state.q
                                                        ? "Sin resultados para la búsqueda"
                                                        : "No hay registros disponibles"}
                                                </td>
                                            </tr>
                                        ) : (
                                            items.map((f, idx) => {
                                                const rowId = String(f?.folio ?? f?.idticket ?? idx);
                                                const isActive = selectedRowId === rowId;

                                                return (
                                                    <tr
                                                        key={`${rowId}-${idx}`}
                                                        className={isActive ? "row-active" : ""}
                                                        onClick={() => this.onSelectRow(rowId)}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <td className="v-mono">{f.idticket || "-"}</td>
                                                        <td>{f.tipo_factura || ""}</td>
                                                        <td className="v-mono">{f.folio || ""}</td>
                                                        <td>{f.nombre || ""}</td>
                                                        <td className="v-mono">{f.rfc || ""}</td>
                                                        <td className="v-num">{this.money(f.cantidad)}</td>
                                                        <td className="v-mono">{f.moneda || ""}</td>
                                                        <td className="v-mono">{f.afiliacion || ""}</td>
                                                        <td className="v-mono">{f.banco || ""}</td>
                                                        <td className="v-mono">{f.hora || ""}</td>
                                                        <td>
                                                            <span className={`v-badge ${this.getEstatusClass(f.estatus)}`}>
                                                                {f.estatus || ""}
                                                            </span>
                                                        </td>
                                                        <td>{this.renderFacturaIcons(f)}</td>
                                                        <td onClick={(e) => e.stopPropagation()}>
                                                            <button
                                                                type="button"
                                                                className="v-miniBtn"
                                                                onClick={(e) => this.openDetalle(f, e)}
                                                                disabled={loading}
                                                            >
                                                                Ver
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}